import { db, functions } from "./firebase";

const COLLECTIONS = {
  RUNS: "dermBenchRuns",
  IMAGES: "dermBenchImages",
  DATASET_CONFIG: "systemConfig",
};

export async function callDermBenchImageFetcher(payload) {
  const fn = functions.httpsCallable("dermBenchImageFetcher", { timeout: 540000 });
  const res = await fn(payload);
  return res.data;
}

export async function callDermBenchStartRun(payload) {
  const fn = functions.httpsCallable("dermBenchStartRun", { timeout: 120000 });
  const res = await fn(payload);
  return res.data;
}

export async function cancelDermBenchRun(runId) {
  const normalizedRunId = String(runId || "").trim();
  if (!normalizedRunId) throw new Error("runId is required");
  await db.collection(COLLECTIONS.RUNS).doc(normalizedRunId).set(
    {
      cancelRequested: true,
      status: "cancelling",
      updatedAt: new Date(),
    },
    { merge: true }
  );
}

export async function listDermBenchRuns(limit = 20) {
  const safeLimit = Math.min(Math.max(1, Number(limit) || 20), 100);
  const snap = await db
    .collection(COLLECTIONS.RUNS)
    .orderBy("startedAt", "desc")
    .limit(safeLimit)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getDermBenchRunById(runId) {
  const normalizedRunId = String(runId || "").trim();
  if (!normalizedRunId) return null;
  const snap = await db.collection(COLLECTIONS.RUNS).doc(normalizedRunId).get();
  return snap.exists ? { id: snap.id, ...snap.data() } : null;
}

export function subscribeToDermBenchRun(runId, callback) {
  const normalizedRunId = String(runId || "").trim();
  if (!normalizedRunId || typeof callback !== "function") return () => {};
  return db.collection(COLLECTIONS.RUNS).doc(normalizedRunId).onSnapshot((snap) => {
    callback(snap.exists ? { id: snap.id, ...snap.data() } : null);
  });
}

export async function getDermBenchImageById(imageId) {
  const normalizedImageId = String(imageId || "").trim();
  if (!normalizedImageId) return null;
  const snap = await db.collection(COLLECTIONS.IMAGES).doc(normalizedImageId).get();
  return snap.exists ? { id: snap.id, ...snap.data() } : null;
}

export async function getDermBenchDatasetConfig() {
  const snap = await db.collection(COLLECTIONS.DATASET_CONFIG).doc("dermBenchDatasets").get();
  return snap.exists ? snap.data() : null;
}

export async function setDermBenchActiveDataset(datasetId) {
  const normalizedDatasetId = String(datasetId || "").trim();
  if (!normalizedDatasetId) throw new Error("datasetId is required");
  await db.collection(COLLECTIONS.DATASET_CONFIG).doc("dermBenchDatasets").set(
    {
      activeDataset: normalizedDatasetId,
      updatedAt: new Date(),
    },
    { merge: true }
  );
}
